import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchProject } from 'src/services/napi/projects/fetchProject';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { useNotification } from '../../../providers/notificationsProvider';

const useGetProject = async (): Promise<Project | undefined> => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject?._id) {
    return;
  }

  const { _id: projectId } = currentProject;
  const data = await fetchProject(projectId);

  return data?.project;
};

export const useProject = () => {
  const { notify } = useNotification();

  return useQuery([QueryKey.PROJECT], () => useGetProject(), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
    }
  });
};
